module.exports = __webpack_public_path__ + "img/image26.9f9f11cf.png";